import { useCallback, useRef, RefObject } from 'react';
import { Map as NewbuildingMapComponent } from '@cian/frontend-newbuilding-map-component';
import { useSelector } from 'react-redux';

import { getDisplayName, getGeoCoordinates } from '../../../selectors/newbuilding';
import { IInfrastructureItem } from '../../../types/map';

type TSetRoutingStart = (geoItem?: IInfrastructureItem) => void;
type TSetDefaultState = () => void;

export const useMapControls = (): [RefObject<NewbuildingMapComponent>, TSetRoutingStart, TSetDefaultState] => {
  const pinCoordinates = useSelector(getGeoCoordinates);
  const newbuildingName = useSelector(getDisplayName);

  const mapRef = useRef<NewbuildingMapComponent>(null);

  const setRoutingStart = useCallback(
    (geoItem?: IInfrastructureItem) => {
      if (mapRef.current) {
        const from = pinCoordinates ? { coordinates: pinCoordinates, fixed: true, label: newbuildingName } : undefined;
        const to = geoItem ? { coordinates: geoItem.coordinates } : undefined;

        mapRef.current.startRouting(from, to, 'properties.name === "main" && geometry.type === "Polygon"');
      }
    },
    [pinCoordinates, newbuildingName],
  );

  const setDefaultState = useCallback(() => {
    if (mapRef.current) {
      mapRef.current.resetMapState();
    }
  }, []);

  return [mapRef, setRoutingStart, setDefaultState];
};
